<template>
    <LoadingComponent :props="loading" />

    <div id="company" class="db-card db-tab-div active">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("menu.license") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="border-b bg-gray-100 p-3 px-5">
            <h2 class="text-base mb-1">{{ $t('label.important') }}</h2>
            <p class="text-sm">{{ $t('message.license_message') }}</p>
        </div>
        <div class="db-card-body">
            <form @submit.prevent="save" class="w-full" style="display:none">
                <div class="form-row">
                    <div class="form-col-12 sm:form-col-6">
                        <label for="license_key" class="db-field-title required">{{ $t("label.license_code") }}</label>
                        <input v-model="form.license_key" v-bind:class="errors.license_key ? 'invalid' : ''" type="text"
                            id="license_key" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.license_key">{{ errors.license_key[0] }}</small>
                    </div>
                    <div class="form-col-12">
                        <button type="submit" class="db-btn text-white bg-primary">
                            <i class="lab lab-fill-save"></i>
                            <span>{{ $t("button.save") }}</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";

export default {
    name: "LicenseComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            form: {
                license_key: "",
            },
            errors: {},
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("license/lists")
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        Object.assign(this.form, res.data.data);
                    }
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        save: function () {
            try {
                this.loading.isActive = true;
                this.$store.dispatch("license/save", this.form).then((res) => {
                    this.loading.isActive = false;
                    alertService.successFlip(
                        res.config.method === "put" ?? 0,
                        this.$t("menu.license")
                    );
                    this.errors = {};
                }).catch((err) => {
                    this.loading.isActive = false;
                    this.errors = err.response.data.errors;
                });
            } catch (err) {
                this.loading.isActive = false;
                alertService.error(err);
            }
        },
    },
};
</script>